import { render } from "./TotalBreakdown.vue?vue&type=template&id=3d09b6c2&scoped=true"
import script from "./TotalBreakdown.vue?vue&type=script&lang=js"
export * from "./TotalBreakdown.vue?vue&type=script&lang=js"

import "./TotalBreakdown.vue?vue&type=style&index=0&id=3d09b6c2&scoped=true&lang=scss"

import exportComponent from "C:\\agent\\_work\\860\\s\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d09b6c2"]])

export default __exports__